import React from "react";
import { motion } from "framer-motion";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ArrowLeft } from "lucide-react";

import SidebarLayout from "@/components/SidebarLayout";
import { useAuth } from "@/context/AuthContext";


const MODULE_PLAN_HINT = {
    outreach: "starter",
    ai_universe: "pro",
    civilization: "pro",
    marketplace: "business",
    module_builder: "business",
};

const PLAN_PRICE = { starter: 29, pro: 79, business: 149 };


export default function Upgrade() {
    const [sp] = useSearchParams();
    const nav = useNavigate();
    const { user } = useAuth();
    const module = sp.get("module") || "outreach";
    const suggestedPlan = MODULE_PLAN_HINT[module] || "starter";

    return (
        <SidebarLayout>
            <div className="max-w-2xl mx-auto py-20 px-4">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="rounded-2xl border border-[var(--color-primary)]/30 bg-gradient-to-br from-[var(--color-panel-ai)] to-[var(--color-card)] p-8 text-center"
                    data-testid="upgrade-interstitial"
                >
                    <div className="mx-auto h-12 w-12 rounded-full bg-[var(--color-primary)]/15 flex items-center justify-center text-[var(--color-primary)]">
                        <Sparkles className="h-6 w-6" />
                    </div>
                    <h1 className="mt-5 text-2xl font-semibold">
                        Sblocca <span className="capitalize">{module.replace(/_/g, " ")}</span>{" "}
                        con <span className="text-[var(--color-primary)]">{suggestedPlan}</span>
                    </h1>
                    <p className="mt-2 text-sm text-text-secondary">
                        Attiva {suggestedPlan.charAt(0).toUpperCase() + suggestedPlan.slice(1)} a{" "}
                        <strong className="text-text-main">${PLAN_PRICE[suggestedPlan] || 29}/mese</strong>,
                        cancel anytime. Se preferisci confrontare tutti i piani prima, vai su{" "}
                        <Link to="/app/subscription" className="text-[var(--color-secondary)] hover:underline">
                            Pricing
                        </Link>
                        .
                    </p>
                    <div className="mt-6 flex justify-center gap-3">
                        <Link
                            to="/app/subscription"
                            data-testid="upgrade-interstitial-cta"
                            className="inline-flex items-center gap-2 rounded-full bg-white hover:bg-[#EDEDED] px-5 py-2 text-sm font-medium text-black hover:opacity-90"
                        >
                            <Sparkles className="h-3.5 w-3.5" />
                            Vai ai piani
                            <ArrowRight className="h-3.5 w-3.5" />
                        </Link>
                        <button
                            onClick={() => nav("/dashboard")}
                            data-testid="upgrade-dismiss"
                            className="inline-flex items-center gap-2 rounded-full border border-[var(--color-border)] px-5 py-2 text-sm text-text-secondary hover:text-text-main hover:border-text-secondary/40"
                        >
                            <ArrowLeft className="h-3.5 w-3.5" />
                            Torna alla dashboard
                        </button>
                    </div>
                    {user?.plan_id && (
                        <p className="mt-6 text-[11px] text-text-secondary">
                            Piano attuale: <strong className="text-text-main capitalize">{user.plan_id}</strong>
                        </p>
                    )}
                </motion.div>
            </div>
        </SidebarLayout>
    );
}
